// extracted by mini-css-extract-plugin
module.exports = {"header":"Login_header__ehUb-","logo":"Login_logo__3dScP"};